import Blue from "~/core";

new Blue({
  name: "Jurisdiction Contact List",
  selector: ".jurisdiction-contacts-table",
  setup(table) {

    const contacts = JSON.parse(table.dataset.contacts);
    const pageSize = parseInt(table.dataset.pageSize);
    let currentPage = parseInt(table.dataset.currentPage);

    const goToTop = () => {
      document.querySelector('.jurisdiction-contacts').scrollIntoView({ behavior: 'smooth' });
    }

    const renderPagination = () => {

      const pageNumbersTop = document.querySelector('.jurisdiction-contacts .pageNumbersTop');
      const pageNumbersBottom = document.querySelector('.jurisdiction-contacts .pageNumbersBottom');
      pageNumbersTop.innerHTML = '';
      pageNumbersBottom.innerHTML = '';

      const totalPages = Math.ceil(contacts.length / pageSize);
      const pagesForPager = determinePagesForPager(currentPage, totalPages);

      const createPageButton = (page, isDisabled = false) => {
        const button = document.createElement('button');
        button.innerText = page;
        button.className = (page === currentPage) ? 'active' : '';
        button.classList.add('btn');
        if (isDisabled) {
          button.disabled = true;
        } else {
          button.onclick = () => goToPage(page);
        }
        return button;
      };

      // Always render first page button
      pageNumbersTop.appendChild(createPageButton(1));
      pageNumbersBottom.appendChild(createPageButton(1));

      // If total pages is greater than 5 and current page is greater than 3, render ellipsis
      if (totalPages > 5 && currentPage > 3) {
        const ellipsis = createPageButton('...', true);
        pageNumbersTop.appendChild(ellipsis);
        pageNumbersBottom.appendChild(ellipsis.cloneNode(true));
      }

      // Render buttons based on result of determinePagesForPager
      pagesForPager.forEach(page => {
        pageNumbersTop.appendChild(createPageButton(page));
        pageNumbersBottom.appendChild(createPageButton(page));
      });

      // If total pages is greater than 5 and current page is less than total pages - 2, render ellipsis
      if (totalPages > 5 && currentPage < totalPages - 2) {
        const ellipsis = createPageButton('...', true);
        pageNumbersTop.appendChild(ellipsis);
        pageNumbersBottom.appendChild(ellipsis.cloneNode(true));
      }

      // Always render last page button
      pageNumbersTop.appendChild(createPageButton(totalPages));
      pageNumbersBottom.appendChild(createPageButton(totalPages));
    }

    const MaximumNumberOfPagesForPager = 3;
    const DesiredRange = 3;

    function determinePagesForPager(currentPageNumber, totalPages) {
      let pagesForPager = [];
      let numberOfPagesInPager = 0;

      if (totalPages >= 3) {
        if (isNotFirstOrLastPage(currentPageNumber, totalPages)) {
          pagesForPager.push(currentPageNumber);
          numberOfPagesInPager++;
        }

        for (let i = 1; i <= DesiredRange; i++) {
          if (hasLessThanMaximumPagesInPager(numberOfPagesInPager)) {
            if (currentPageNumber - i > 1) {
              pagesForPager.push(currentPageNumber - i);
              numberOfPagesInPager++;
            }
          }

          if (hasLessThanMaximumPagesInPager(numberOfPagesInPager)) {
            if (currentPageNumber + i < totalPages) {
              pagesForPager.push(currentPageNumber + i);
              numberOfPagesInPager++;
            }
          }
        }
      }

      return pagesForPager.sort((a, b) => a - b);
    }

    function isNotLastPage(possiblePageNumber, totalPages) {
      return possiblePageNumber < totalPages;
    }

    function hasLessThanMaximumPagesInPager(numberOfPagesInPager) {
      return numberOfPagesInPager < MaximumNumberOfPagesForPager;
    }

    function isNotFirstOrLastPage(page, totalPages) {
      return isNotFirstPage(page) && isNotLastPage(page, totalPages);
    }

    function isNotFirstPage(page) {
      return page !== 1;
    }

    const renderTable = () => {
      const tableBody = table.querySelector('tbody');
      tableBody.innerHTML = '';

      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      const paginatedContacts = contacts.slice(start, end);

      paginatedContacts.forEach(contact => {

        const firstLetter = contact.Municipality.charAt(0).toUpperCase();
        if (!tableBody.querySelector(`tr[data-letter="${firstLetter}"]`)) {
          const letterRow = `
            <tr data-letter="${firstLetter}">
              <th colspan="1" class="letter-row">${firstLetter}</td>
              <th colspan="2"></td>
              <th class="letter-row">
                <div class="button-container">
                    <button class="btn btn-top">Top</button></td>
                </div>              
            </tr>
          `;
          tableBody.innerHTML += letterRow;
        }
        const row = `
            <tr>
                <td>${contact.Municipality}</td>
                <td>${contact.ContactName}</td>
                <td>${contact.Email}</td>
                <td>${contact.Phone}</td>
            </tr>
        `;
        tableBody.innerHTML += row;
      });

      document.querySelectorAll('.btn-top').forEach(button => {
        button.addEventListener('click', goToTop);
      });

      if(Math.ceil(contacts.length / pageSize) > 1) {
        renderPagination();
      }
    }

    const goToPage = (page) => {
      currentPage = page;
      table.dataset.currentPage = page;
      renderTable();
      goToTop();
    }

    const prevPage = () => {
      if (currentPage > 1) {
        goToPage(currentPage - 1);
      }
    }

    const nextPage = () => {
      const totalPages = Math.ceil(contacts.length / pageSize);
      if (currentPage < totalPages) {
        goToPage(currentPage + 1);
      }
    }

    if(Math.ceil(contacts.length / pageSize) > 1) {
    document.querySelector('.jurisdiction-contacts .prevPageTop').addEventListener('click', prevPage);
    document.querySelector('.jurisdiction-contacts .nextPageTop').addEventListener('click', nextPage);
    document.querySelector('.jurisdiction-contacts .prevPageBottom').addEventListener('click', prevPage);
    document.querySelector('.jurisdiction-contacts .nextPageBottom').addEventListener('click', nextPage);
    }
    else {
      document.querySelectorAll('.jurisdiction-contacts .pagination').forEach(pagination => {
        pagination.style.display = 'none';
      });
    }
    
    renderTable();
  }
});